var _rect, _rect2, _path, _circle, _circle2, _circle3, _circle4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFootergoldplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 174,
    viewBox: "0 0 373 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.00781,
    y: 5,
    width: 362.984,
    height: 164,
    rx: 23,
    fill: "#F3F4F5",
    stroke: "#E2B630",
    strokeWidth: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.75781,
    y: 7.75,
    width: 357.484,
    height: 157.5,
    rx: 20.25,
    fill: "#F2C744",
    stroke: "#BF7E06",
    strokeWidth: 4.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.045 52.122C103.045 50.44 103.48 50.034 106.061 50.034C110.585 50.034 112.847 52.064 112.847 59.053C112.847 64.476 111.803 68.014 106.061 68.014C103.48 68.014 103.045 67.608 103.045 65.926V52.122ZM97.3615 50.034C99.5945 50.034 100.087 50.556 100.087 51.948V66.1C100.087 67.492 99.5945 68.014 97.3615 68.014V69H106.989C111.107 69 116.211 65.81 116.211 59.024C116.211 52.238 111.049 49.048 106.757 49.048H97.3615V50.034ZM124.641 69V68.014C122.147 68.014 121.567 67.608 121.567 66.506C121.567 65.694 122.408 63.954 122.901 62.33H129.745C130.528 64.012 131.369 66.332 131.369 66.941C131.369 67.782 131.253 68.014 129.078 68.014V69H137.14V68.014C135.458 68.014 134.791 67.492 133.921 65.259L127.57 48.932H126.526L120.668 64.94C120.03 66.709 119.421 68.014 117.072 68.014V69H124.641ZM123.307 61.112L126.207 53.485L129.281 61.112H123.307ZM137.314 49.048V50.034C139.605 50.034 140.098 50.556 140.098 51.948V66.1C140.098 67.492 139.605 68.014 137.314 68.014V69H145.84V68.014C143.549 68.014 143.056 67.492 143.056 66.1V51.948C143.056 50.556 143.549 50.034 145.84 50.034V49.048H137.314ZM162.283 61.547H161.384C160.108 67.144 157.092 68.014 154.598 68.014C153.119 68.014 152.481 67.492 152.481 66.1V51.948C152.481 50.556 152.974 50.034 155.265 50.034V49.048H146.971V50.034C149.03 50.034 149.523 50.556 149.523 51.948V66.1C149.523 67.492 149.03 68.014 146.913 68.014V69H162.109L162.283 61.547ZM162.65 50.034C164.158 50.034 164.709 50.266 165.492 51.803L169.929 60.532V66.1C169.929 67.492 169.436 68.014 166.913 68.014V69H176.019V68.014C173.38 68.014 172.887 67.492 172.887 66.1V60.532L176.976 52.789C178.049 50.759 178.426 50.034 180.514 50.034V49.048H173.873V50.034C175.7 50.034 176.338 50.382 176.338 50.991C176.338 52.47 172.887 57.864 172.336 59.082C171.843 57.777 168.45 52.006 168.45 51.02C168.45 50.324 169.146 50.034 170.886 50.034V49.048H162.65V50.034ZM190.906 66.1C190.906 67.492 190.413 68.014 188.238 68.014V69H199.287C204.188 69 205.899 65.404 205.899 63.548C205.899 60.474 203.521 58.56 199.229 58.415V58.357C202.303 58.357 204.913 56.53 204.913 53.978C204.913 51.6 203.115 49.048 197.605 49.048H188.238V50.034C190.413 50.034 190.906 50.556 190.906 51.948V66.1ZM198.475 59.024C201.317 59.024 202.535 60.822 202.535 63.548C202.535 66.419 201.259 68.014 196.851 68.014C194.415 68.014 193.864 67.521 193.864 66.013V59.024H198.475ZM193.864 58.038V51.484C193.864 50.672 194.125 50.034 196.503 50.034C200.041 50.034 201.549 51.194 201.549 54.21C201.549 56.472 200.621 58.038 196.735 58.038H193.864ZM224.894 64.824C224.894 65.781 224.604 67.144 223.821 67.144C221.356 67.144 223.125 60.068 217.528 59.169V59.111C220.921 59.111 224.459 57.69 224.459 54.036C224.459 52.064 222.98 49.048 218.195 49.048H207.726V50.034C209.93 50.034 210.423 50.556 210.423 51.948V66.1C210.423 67.492 209.93 68.014 207.726 68.014V69H216.252V68.014C213.874 68.014 213.381 67.492 213.381 66.1V59.314H214.512C217.586 59.314 218.978 59.952 218.978 64.592C218.978 67.26 220.08 69.174 222.255 69.174C224.923 69.174 225.706 67.202 225.706 64.824H224.894ZM213.381 51.716C213.381 50.527 214.164 50.034 216.658 50.034C220.08 50.034 221.327 51.803 221.327 54.442C221.327 57.487 219.326 58.328 216.716 58.328C215.382 58.328 214.222 58.299 213.381 58.27V51.716ZM235.102 49.048H226.576V50.034C228.867 50.034 229.36 50.556 229.36 51.948V63.49C229.36 67.55 232.231 69.348 236.697 69.348C240.873 69.348 243.918 67.028 243.918 62.852V52.818C243.918 51.252 244.208 50.034 246.76 50.034V49.048H239.771V50.034C242.584 50.034 242.874 51.252 242.874 52.818V62.62C242.874 65.868 241.279 68.362 237.045 68.362C233.855 68.362 232.318 66.68 232.318 63.577V51.948C232.318 50.556 232.811 50.034 235.102 50.034V49.048ZM247.678 49.048V50.034C249.969 50.034 250.462 50.556 250.462 51.948V66.1C250.462 67.492 249.969 68.014 247.678 68.014V69H256.204V68.014C253.913 68.014 253.42 67.492 253.42 66.1V51.948C253.42 50.556 253.913 50.034 256.204 50.034V49.048H247.678ZM257.625 49.048V50.034C259.104 50.034 259.626 50.15 260.554 51.223V66.1C260.554 67.492 260.061 68.014 257.683 68.014V69H264.817V68.014C262.265 68.014 261.772 67.492 261.772 66.1V53.05H261.83L273.227 69.174H274.358V51.948C274.358 50.556 274.851 50.034 276.881 50.034V49.048H270.269V50.034C272.647 50.034 273.14 50.556 273.14 51.948V63.983H273.082L262.642 49.048H257.625Z",
    fill: "#BF7E06"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.9212,
    cy: 34.0955,
    r: 7.22835,
    fill: "#BF7E06"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.283,
    cy: 34.0955,
    r: 7.22835,
    fill: "#BF7E06"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.9212,
    cy: 144.93,
    r: 7.22835,
    fill: "#E69B12"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.228,
    cy: 144.93,
    r: 7.22835,
    fill: "#BF7E06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8284 31.1729L36.1715 36.8297",
    stroke: "black",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8284 36.8301L36.1715 31.1732",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M337.657 31.1729L332 36.8297",
    stroke: "black",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M337.657 36.8301L332 31.1732",
    stroke: "black",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8284 142.001L36.1715 147.658",
    stroke: "black",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8284 147.658L36.1715 142.001",
    stroke: "black",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M337.657 142.001L332 147.658",
    stroke: "black",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M337.657 147.658L332 142.001",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootergoldplate);
export default __webpack_public_path__ + "static/media/footergoldplate.4cf8014453b7560b8d858fe5473fd41c.svg";
export { ForwardRef as ReactComponent };